import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDroplet, faMartiniGlass } from '@fortawesome/sharp-regular-svg-icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import AlcoholTracker from './AlcoholTracker';
import WaterTracker from './WaterTracker';

function HydrationTracker(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openHydration, setOpenHydration] = useState(false);
  const [openAlcohol, setOpenAlcohol] = useState(false);

  const handleHydration = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenHydration(true);
    }, 500);
  };

  const handleAlcohol = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenAlcohol(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openHydration) {
      const hydration = document.getElementById('snm-hydration');
      setTimeout(() => {
        hydration?.classList.add('slide-in');
      }, 300);
    }
  }, [openHydration]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  useEffect(() => {
    if (openAlcohol) {
      const alcohol = document.getElementById('snm-alcohol');
      setTimeout(() => {
        alcohol?.classList.add('slide-in');
      }, 300);
    }
  }, [openAlcohol]);

  const handleBackToMain = () => {
    if (openHydration) {
      const hydration = document.getElementById('snm-hydration');
      hydration?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenHydration(false);
        setAreaPicker(true);
      }, 500);
    }

    if (openAlcohol) {
      const alcohol = document.getElementById('snm-alcohol');
      alcohol?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenAlcohol(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleHydration}
              type="button"
              aria-label={t('T135')}
            >
              <div>
                <FontAwesomeIcon icon={faDroplet} className="mood-icon" /> {t('T135')}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
            <button
              className="mood-area"
              onClick={handleAlcohol}
              type="button"
              aria-label={t('T136')}
            >
              <div>
                <FontAwesomeIcon icon={faMartiniGlass} className="mood-icon" /> {t('T136')}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openHydration && (
        <WaterTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
      {openAlcohol && (
        <AlcoholTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default HydrationTracker;
